import { Text } from '@vidahealth/vida-ui';
import { View } from 'react-native';

import type { Address } from '../types';
import { composeCityLine } from '../utils/composeCityLine';

type Props = {
  address: Address;
  testID: string;
};

// testID lives on the wrapping View, not the vida-ui Text — vida-ui's web Text
// leaks unknown props (incl. testID) onto the DOM node, which React warns about.
const AddressLine = ({ text, testID }: { text: string; testID: string }) =>
  text ? (
    <View testID={testID}>
      <Text size='md' className='text-typography-900'>
        {text}
      </Text>
    </View>
  ) : null;

/**
 * A plain (non-diffed) address block — street, optional unit, and the composed
 * city/state/ZIP line. Used in the warning / undeliverable / error dialogs and
 * the "what you typed" confirm card.
 */
export function AddressSummary({ address, testID }: Props) {
  return (
    <View testID={testID} className='gap-1'>
      <AddressLine text={address.addressLine1} testID={`${testID}-line1`} />
      <AddressLine text={address.addressLine2 ?? ''} testID={`${testID}-line2`} />
      <AddressLine text={composeCityLine(address)} testID={`${testID}-city-line`} />
    </View>
  );
}
